import reactStringReplace from 'react-string-replace';

import { TextButton } from './buttons/TextButton';

interface InteractiveTranslationProps {
    translation: string;
    onClick: () => void;
}

export const InteractiveTranslation = ({ translation, onClick }: InteractiveTranslationProps) => {
    return (
        <>
            {reactStringReplace(translation, /\[([^\]]+)]/g, (match, i) => {
                return (
                    <TextButton key={i} onClick={onClick}>
                        {match}
                    </TextButton>
                );
            })}
        </>
    );
};
